
import { FC } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { formatDistanceToNow } from 'date-fns';
import { MoreHorizontal, BadgeCheck } from "lucide-react";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { motion } from "framer-motion";

interface PostHeaderProps {
  post: {
    profiles: {
      username: string;
      avatar_url: string;
      is_pro?: boolean;
    };
    created_at: string;
    user_id: string;
  };
  isOwner: boolean;
  onDelete: () => Promise<void>;
}

export const PostHeader: FC<PostHeaderProps> = ({ post, isOwner, onDelete }) => {
  console.log('Post header props:', { post, isOwner });
  console.log('Is pro status:', post.profiles.is_pro);

  const isDeepVoid = post.user_id === '00000000-0000-0000-0000-000000000000';

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Link to={`/profile/${post.user_id}`}>
          {isDeepVoid ? (
            <div className="relative w-10 h-10 cursor-pointer">
              <motion.div 
                className="absolute inset-0 rounded-full bg-gradient-to-r from-[#00F0FF] to-[#0EA5E9] opacity-50"
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.5, 0.3, 0.5],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "linear"
                }}
              />
              <motion.div 
                className="absolute inset-0 rounded-full bg-black border-2 border-[#00F0FF] shadow-lg shadow-[#00F0FF]/50"
                style={{
                  background: "radial-gradient(circle at center, #000000 60%, #0EA5E9 100%)",
                }}
              />
            </div>
          ) : (
            <Avatar>
              <AvatarImage src={post.profiles.avatar_url} />
              <AvatarFallback>{post.profiles.username[0]}</AvatarFallback>
            </Avatar>
          )}
        </Link>
        <div>
          <div className="flex items-center gap-1">
            <Link 
              to={`/profile/${post.user_id}`}
              className="font-semibold hover:text-flux-cyan transition-colors"
            >
              @{post.profiles.username}
            </Link>
            {post.profiles.is_pro && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <BadgeCheck className="h-4 w-4 text-yellow-500 animate-[pulse_2s_ease-in-out_infinite] drop-shadow-[0_0_4px_rgba(234,179,8,0.4)]" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Pro Member</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
          <span className="text-sm text-muted-foreground">
            {formatDistanceToNow(new Date(post.created_at), { addSuffix: true })}
          </span>
        </div>
      </div>
      {isOwner && (
        <DropdownMenu>
          <DropdownMenuTrigger>
            <MoreHorizontal className="h-5 w-5 text-muted-foreground" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={onDelete} className="text-red-500">
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
